export default "__VITE_ASSET__yzzIyeVT__"